// eslint-disable-next-line import/prefer-default-export
const email_address_override_field = {
  override_field: "override_email_address",
  override_source_field: "email_override_source_dropdown_option_id"
}

const phone_override_field = {
  override_field: "override_phone_number",
  override_source_field: "phone_override_source_dropdown_option_id"
}
export const OVERRIDE_FIELDS = {
  customer: {
    email_address: email_address_override_field,
    cell_phone_number: phone_override_field,
    home_phone_number: phone_override_field,
    employer_phone: phone_override_field,
    supervisor_phone: phone_override_field,
  }
}
